module.exports = __webpack_public_path__ + "static/media/simplonbp-bold-webfont.e23fa535.ttf";